"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.XjbRechargeInitRequest = void 0;
var XjbRechargeInitRequest = /** @class */ (function () {
    function XjbRechargeInitRequest() {
    }
    return XjbRechargeInitRequest;
}());
exports.XjbRechargeInitRequest = XjbRechargeInitRequest;
;
//# sourceMappingURL=xjbRechargeInit.request.js.map